import { useCallback, useRef, useState } from "react";
import { ConnectionStatus } from "./mock-providers";

export function useMockConnections() {
    const [connections, setConnections] = useState<Record<string, ConnectionStatus>>({});
    const timersRef = useRef<Record<string, ReturnType<typeof setTimeout>>>({});

    const connect = useCallback((providerId: string) => {
        if (timersRef.current[providerId]) return;

        setConnections((prev) => ({ ...prev, [providerId]: "authorizing" }));

        timersRef.current[providerId] = setTimeout(() => {
            setConnections((prev) => ({ ...prev, [providerId]: "connected" }));
            delete timersRef.current[providerId];
        }, 15000);
    }, []);

    const disconnect = useCallback((providerId: string) => {
        if (timersRef.current[providerId]) {
            clearTimeout(timersRef.current[providerId]);
            delete timersRef.current[providerId];
        }
        setConnections((prev) => ({ ...prev, [providerId]: "idle" }));
    }, []);

    const getStatus = useCallback(
        (providerId: string): ConnectionStatus => {
            return connections[providerId] ?? "idle";
        },
        [connections]
    );

    return { connect, disconnect, getStatus };
}
